<template lang="html">
  <div>
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.appManagement')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.appBaic')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="">
      <!-- APP基本信息页 start -->
      <div class="flex-col verifone-panel edit-body" v-show="showType === 0">
        <!-- APK包 -->
        <div class="flex-row edit-app-item"  v-if="isReloadData">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.apkFile')}}</div>
          </div>
          <el-input v-model="apkFileinput" :disabled="true" :placeholder="$t('message.uploadTipAPK')" class="input-margin"></el-input>
          <el-button v-if="queryFlag" icon="el-icon-upload2" class="verifone-btn" type="primary" plain @click="addFileInputClick">{{$t('message.upload')}}</el-button>
          <el-button v-else disabled icon="el-icon-upload2" class="verifone-btn" type="primary" plain @click="addFileInputClick">{{$t('message.upload')}}</el-button>
          <input type="file" id="apkFile" class="addFileInput" ref="addFileInput" accept=".apk" @change="clickAddFile">
        </div>

        <!-- 图标 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.icon')}}</div>
          </div>
          <img  class="appIconImg" :src="logo">
          <!-- @click="addAppIconClick" -->
          <div class="flex-col icon-tip-con"><span>JPEG/JPG/PNG</span></div>
          <input type="file" class="addFileInput" @change="clickAddAppIcon" ref="appIconUpload">
        </div>

        <!-- 包名 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t("message.packageName")}}</div>
          </div>
          <el-input v-model="packageName" :disabled="true" :placeholder="$t('message.charTip50')"  oninput="if(value.length > 60) value = value.slice(0, 60)"></el-input>
        </div>

        <!-- APP名称 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.appName')}}</div>
          </div>
          <el-input v-model="appName" :placeholder="$t('message.charTip50')" oninput="if(value.length > 50) value = value.slice(0, 50)"></el-input>
        </div>

        <!-- 介绍 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t("message.intoduction")}}</div>
          </div>
          <el-input v-model="description"   type="textarea" :rows="3" :placeholder="$t('message.charTip200')" oninput="if(value.length > 200) value = value.slice(0, 200)"></el-input>
        </div>

        <!-- 公司 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.developer')}}</div>
          </div>
          <el-input v-model="company" :placeholder="$t('message.charTip50')" oninput="if(value.length > 50) value = value.slice(0, 50)"></el-input>
        </div>

        <!-- 版本号 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.version')}}</div>
          </div>
          <el-input v-model="version" :disabled="true" :placeholder="$t('message.versionExample')"></el-input>
        </div>

        <!-- 卸载 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <span class="redStar">*</span>
            <div class="item-name">{{$t('message.uninstall')}}</div>
          </div>
          <el-select v-model="enableUninstall" :placeholder="$t('message.pleaseChoose')">
            <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <!-- APP参数 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <div class="long-item-name">{{$t('message.appParameter')}}</div>
          </div>
          <el-input v-model="appParameterFile" :placeholder="$t('message.uploadTipXML')" :disabled="true" class="input-margin"></el-input>
          <el-button v-if="queryFlag" icon="el-icon-upload2" class="verifone-btn" type="primary" plain @click="appParameterInputClick">{{$t('message.upload')}}</el-button>
          <el-button v-else disabled icon="el-icon-upload2" class="verifone-btn" type="primary" plain @click="appParameterInputClick">{{$t('message.upload')}}</el-button>
          <el-button icon="el-icon-edit" class="verifone-btn" type="success" plain :disabled="appParameterEditFlag" @click="showAppParaDiog" >{{$t('message.edit')}}</el-button>
          <el-button icon="el-icon-document" class="verifone-btn" type="success" plain  :disabled="resourceFileEditFlag" @click="showFileParaDiog" style="width: 125px;">{{$t('message.resourceFile')}}</el-button>
          <input type="file" class="addFileInput" ref="appParameterInput" accept=".xml" @change="clickAddParameter">
        </div>

        <!-- 终端参数模板 -->
        <div class="flex-row edit-app-item">
          <div class="flex-row edit-left">
            <div class="long-item-name">{{$t('message.terminalParameterTemplate')}}</div>
          </div>
          <el-input v-model="terminalParameterFile" :placeholder="$t('message.uploadTipXML')" :disabled="true" class="input-margin"></el-input>
          <el-button v-if="queryFlag" icon="el-icon-upload2" class="verifone-btn" type="primary" plain @click="addTerminalParameterInputClick">{{$t('message.upload')}}</el-button>
          <el-button v-else disabled icon="el-icon-upload2" class="verifone-btn" type="primary" plain >{{$t('message.upload')}}</el-button>
          <el-button type="success" plain class="verifone-btn" icon="el-icon-edit" :disabled="terminalEditFlag" @click="showTerminalDiog">{{$t('message.edit')}}</el-button>
          <input type="file" class="addFileInput" ref="addTerminalParameterInput" accept=".xml" @change="clickAddParameter">
        </div>

        <!--提交按钮-->
        <div class="flex-row footer-contain">
          <el-button type="primary" plain class="verifone-btn" icon="el-icon-close" @click="editCancel" style="margin-right: 10px;">{{$t('message.cancel')}}</el-button>
          <el-button v-if="queryFlag" type="primary" class='verifone-btn' icon="el-icon-document" @click="saveAppMessage">{{$t('message.submit')}}</el-button>
          <el-button v-else disabled type="primary" class='verifone-btn' icon="el-icon-document" @click="saveAppMessage">{{$t('message.submit')}}</el-button>
        </div>
      </div>
      <!-- APP基本信息页 end -->

      <!-- APP参数页 start-->
      <div class="verifone-panel app-body btn-table" v-show="showType === 1">
        <template>
            <el-button type="primary" icon="el-icon-plus" plain class="verifone-btn" @click="addAppParameterTabPane">{{$t('message.add')}}</el-button>
        </template>
        <el-tabs type="card" v-model="appParameterTabIndex" class="verifone-tabs" @tab-click="apTabClick">
            <el-tab-pane v-for="(item,index) in appParameterNameList" :label="item" :name="index" :key="index">
            </el-tab-pane>
        </el-tabs>

        <el-table :data="inputAppParameter" ref="multipleTable">
          <!--数据库字段名-->
          <el-table-column property="dataName" :label="$t('message.databaseName')" width="380">
            <template slot-scope="scope">
              <el-input type="text" style="width:100%;border: none" :placeholder="$t('message.enterContent')"
                        v-model="scope.row.dataName"/>
            </template>
          </el-table-column>
         <!-- 值-->
          <el-table-column property="value" :label="$t('message.value')" width="380">
            <template slot-scope="scope">
              <el-input type="text" style="width:100%;border: none" :placeholder="$t('message.enterContent')"
                        v-model="scope.row.value"></el-input>
            </template>
          </el-table-column>
          <!--输入-->
          <el-table-column  align="center" label="" width="180">
            <template slot-scope="scope">
              <el-button v-if="queryFlag" class="verifone-btn" @click="addAppParameter(scope.row,apSelectedTab)" type="text" size="medium">{{$t('message.enter')}}</el-button>
              <el-button v-else disabled class="verifone-btn" @click="addAppParameter(scope.row,apSelectedTab)" type="text" size="medium">{{$t('message.enter')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="apFilterShowList(operateAppParameterList,apSelectedTab)" :show-header="false" @row-click="appParamterHandleEdit" height="50vh" ref="multipleTable">
          <el-table-column prop="dataName" :label="$t('message.databaseName')" width="380" >
              <template slot-scope="scope">
                  <div v-if="!scope.row.editFlag" >{{ scope.row.dataName}}</div>
                  <span v-if="scope.row.editFlag" class="cell-edit-input">
                      <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.dataName" @blur="clickBB(scope.row)"/>
                  </span>
              </template>
          </el-table-column>
          <el-table-column prop="value" :label="$t('message.value')" width="380">
              <template slot-scope="scope">
                  <div v-if="!scope.row.editFlag" >{{ valueFormatter(scope.row.value) }}</div>
                  <span v-if="scope.row.editFlag" class="cell-edit-input">
                    <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.value" @blur="clickBB(scope.row)"/>
                  </span>
              </template>
          </el-table-column>
          <el-table-column  align="center"  label="" width="180">
              <template slot-scope="scope">
                  <el-button v-if="queryFlag" type="danger" icon="el-icon-close" plain class="verifone-btn" @click="delRowByIndex(scope.row.index, operateAppParameterList)">{{$t('message.delete')}}</el-button>
                  <el-button v-else disabled type="danger" icon="el-icon-close" plain class="verifone-btn" @click="delRowByIndex(scope.row.index, operateAppParameterList)">{{$t('message.delete')}}</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div class="xml-length-container">{{$t('message.totals')}}&nbsp;{{operateAppParameterList.length}}&nbsp;{{$t('message.items')}}</div>
        <!-- 分页 -->
        <div>
          <el-pagination background
            layout="prev, pager, next"
            @current-change="apPageChange"
            :current-page="apCurrentPageNum"
            :page-count="apPageCount" />
        </div>
        <div class="flex-row footer-contain">
         <!-- 删除和提交-->
          <el-button type="primary" plain icon="el-icon-close" class="verifone-btn" @click="initAppData()" style="margin-right: 10px;">{{$t('message.cancel')}}</el-button>
          <el-button v-if="queryFlag" type="primary" icon="el-icon-document" class="verifone-btn" @click="saveAppData()">{{$t('message.submit')}}</el-button>
          <el-button v-else disabled type="primary" icon="el-icon-document" class="verifone-btn" @click="saveAppData()">{{$t('message.submit')}}</el-button>
        </div>
      </div>
      <!-- APP参数页 end-->

      <!-- 终端参数模板页 start-->
      <div class="verifone-panel te-body btn-table" v-show="showType === 2">
        <!-- 新增按钮 -->
        <el-button type="primary" icon="el-icon-plus" class="verifone-btn" plain @click="addTerminalParameterTabPane">
          {{$t('message.add')}}
        </el-button>

        <el-tabs type="card" v-model="terminalParameterTabIndex" class="verifone-tabs" @tab-click="atpTabClick">
          <el-tab-pane v-for="(item,index) in terminalParameterNameList" :label="item" :name="index" :key="index" />
        </el-tabs>

        <!-- 新增行 begin -->
        <el-table  :data="inpuTerminalData">
          <el-table-column property="dataName" :label="$t('message.databaseName')" width="200">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.dataName" :placeholder="$t('message.enterContent')" style="width:100%; border:none" />
            </template>
          </el-table-column>
          <el-table-column property="value" :label="$t('message.defaultValue')" width="110">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.value" :placeholder="$t('message.enterContent')" style="width:100%; border:none" />
            </template>
          </el-table-column>
          <el-table-column property="lengthFixed" :label="$t('message.fixedLength')" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lengthFixed">
                <el-option v-for="item in yesOrNoSelect" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column property="maxLength" :label="$t('message.maxLength')" width="105">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.maxLength" :placeholder="$t('message.enterContent')" style="width:100%;border: none" />
            </template>
          </el-table-column>
          <el-table-column property="bulkEditMark" :label="$t('message.bulkEditMark')" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.bulkEditMark" >
                <el-option v-for="item in yesOrNoSelect" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column property="description" :label="$t('message.description')">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.description" :placeholder="$t('message.enterContent')" style="width:100%;border: none" />
            </template>
          </el-table-column>
          <el-table-column  label="" align="center" width="180">
            <template slot-scope="scope">
              <el-button v-if="queryFlag" class="verifone-btn" @click="addTerminalParameter(scope.row,atpSelectedTab)" type="text" size="medium">{{$t('message.enter')}}</el-button>
              <el-button v-else disabled class="verifone-btn" @click="addTerminalParameter(scope.row,atpSelectedTab)" type="text" size="medium">{{$t('message.enter')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增行 end -->

        <!-- 数据内容 begin -->
        <el-table :data="atpFilterShowList(operateTerminalParameterList,atpSelectedTab)" :show-header="false" @row-click="terminalHandleEdit" height="50vh">
          <el-table-column property="dataName" :label="$t('message.databaseName')" width="200">
            <template slot-scope="scope">
                <span v-if="!scope.row.editFlag" >{{ scope.row.dataName }}</span>
                <span v-if="scope.row.editFlag" class="cell-edit-input">
                  <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.dataName" @blur="clickBB(scope.row)" />
                </span>
            </template>
          </el-table-column>
          <el-table-column property="value" :label="$t('message.defaultValue')" width="110">
            <template slot-scope="scope">
              <span v-if="!scope.row.editFlag" >{{ scope.row.value }}</span>
              <span v-if="scope.row.editFlag" class="cell-edit-input">
                <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.value" @blur="clickBB(scope.row)" />
              </span>
            </template>
          </el-table-column>
          <el-table-column property="lengthFixed" :label="$t('message.fixedLength')" width="120">
            <template slot-scope="scope">
              <span  class="cell-edit-input">
                <el-select v-model="scope.row.lengthFixed" :placeholder="$t('message.enterContent')">
                  <el-option v-for="item in yesOrNoSelect" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </span>
            </template>
          </el-table-column>
          <el-table-column property="maxLength" :label="$t('message.maxLength')" width="105">
            <template slot-scope="scope">
              <div v-if="!scope.row.editFlag" >{{scope.row.maxLength}}</div>
              <span v-if="scope.row.editFlag" class="cell-edit-input">
                <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.maxLength" @blur="clickBB(scope.row)" />
              </span>
            </template>
          </el-table-column>
          <el-table-column property="bulkEditMark" :label="$t('message.bulkEditMark')" width="120">
            <template slot-scope="scope">
              <span  class="cell-edit-input">
                <el-select v-model="scope.row.bulkEditMark" :placeholder="$t('message.enterContent')">
                  <el-option v-for="item in yesOrNoSelect" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </span>
            </template>
          </el-table-column>
          <el-table-column property="description" :label="$t('message.description')">
            <template slot-scope="scope">
              <div v-if="!scope.row.editFlag" >{{ scope.row.description }}</div>
                <span v-if="scope.row.editFlag" class="cell-edit-input">
                  <el-input :placeholder="$t('message.enterContent')" v-model="scope.row.description" @blur="clickBB(scope.row)" />
                </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Operation" width="180">
            <template slot-scope="scope">
              <el-button v-if="queryFlag" type="danger" plain icon="el-icon-close" class="verifone-btn" @click="delRowByIndex(scope.row.index,operateTerminalParameterList)">{{$t('message.delete')}}</el-button>
              <el-button v-else disabled type="danger" plain icon="el-icon-close" class="verifone-btn" @click="delRowByIndex(scope.row.index,operateTerminalParameterList)">{{$t('message.delete')}}</el-button>
            </template>
           </el-table-column>
        </el-table>
        <!-- 数据内容 end -->

        <!-- 数据条目统计 -->
        <div class="xml-length-container">{{$t('message.totals')}}&nbsp;{{operateTerminalParameterList.length}}&nbsp;{{$t('message.items')}}</div>

        <!-- 分页 -->
        <div>
          <el-pagination background
            layout="prev, pager, next"
            @current-change="atpPageChange"
            :current-page="atpCurrentPageNum"
            :page-count="atpPageCount" />
        </div>

        <!-- 底部按钮 -->
        <div class="flex-row footer-contain">
         <!-- 终端参数的返回和提交-->
          <el-button type="primary" class="verifone-btn" plain icon="el-icon-close" @click="initTerminalData()" style="margin-right: 10px;">{{$t('message.cancel')}}</el-button>
          <el-button v-if="queryFlag" type="primary" class="verifone-btn" icon="el-icon-document" @click="saveTerminalData">{{$t('message.submit')}}</el-button>
          <el-button v-else disabled type="primary" class="verifone-btn" icon="el-icon-document" @click="saveTerminalData">{{$t('message.submit')}}</el-button>
        </div>
      </div>
      <!-- 终端参数模板页 end-->

      <!-- 资源文件参数页 start -->
      <div class="verifone-panel file-body btn-table" v-show="showType === 3">

        <!-- 新增 -->
        <el-button type="primary" icon="el-icon-plus" plain class="verifone-btn" @click="openAddResourceFile">{{$t('message.add')}}</el-button>

        <!-- 信息 -->
        <el-table class="file-table" :data="operateFileList" show-header>
          <el-table-column type="index" width="50"/>
          <el-table-column prop="name" :label="$t('message.name')" width="200"/>
          <el-table-column prop="version" :label="$t('message.version')" width="200"/>
          <el-table-column prop="description" :label="$t('message.description')" width="200"/>
          <el-table-column :label="$t('message.operation')" width="240">
            <template slot-scope="scope">
              <a :href = "scope.row.downloadUrl">
                <el-button class="op-btn verifone-btn" type="info" plain icon="el-icon-download" style="width: 100px">{{$t('message.download')}} </el-button>
              </a>
              <el-button class="op-btn verifone-btn" type="danger" plain icon="el-icon-delete" @click="delResourceFile(scope.$index,operateFileList)">{{$t('message.delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 统计 -->
        <div class="xml-length-container">{{$t('message.totals')}}&nbsp;{{operateFileList.length}}&nbsp;{{$t('message.items')}}</div>

        <!-- 删除和提交 -->
        <div class="flex-row footer-contain">
          <el-button class="verifone-btn" plain type="primary"  icon="el-icon-document" @click="saveFileData">{{$t('message.submit')}}</el-button>
          <el-button class="verifone-btn" plain type="primary"  icon="el-icon-close"  @click="initFileListData">{{$t('message.cancel')}}</el-button>
        </div>

      </div>
      <!-- 资源文件参数页 end -->
    </div>

    <!-- 询问是否进行强制编辑 -->
    <el-dialog title="" :visible.sync="forceEditVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.forceEdit')}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="forceEditVisible = false">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="forceEdit">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>

    <!-- 新增资源文件 对话框 -->
    <el-dialog :title="$t('message.resourceFile')" :visible.sync="addFileDialogVisible" width="37%" :before-close="newFileDlgBeforeClose">
      <el-form :model="fileFrom" label-width="100px">
        <el-form-item :label="$t('message.name')">
          <el-input v-model="fileFrom.name" :disabled="true"/>
          <el-input v-model="fileFrom.filename" v-show="false"/>
          <el-button class="verifone-btn" plain type="primary" icon="el-icon-upload2" @click="appResourceFileBtnClick">{{$t('message.upload')}}</el-button>
          <input type="file"  class="addFileInput" ref="appResourceFileBtn"  @change="clickAddAppResourceFile">
        </el-form-item>
        <el-form-item :label="$t('message.resourceVersion')">
          <el-input v-model="fileFrom.version"/>
        </el-form-item>
        <el-form-item :label="$t('message.description')">
          <el-input v-model="fileFrom.description" type="textarea" :row="2"/>
        </el-form-item>
        <el-form-item>
          <el-button class="verifone-btn" plain type="primary" icon="el-icon-document" @click="newFileInfoSubmit">{{$t('message.submit')}}</el-button>
          <el-button class="verifone-btn" plain type="primary" icon="el-icon-refresh-left" @click="newFileInfoReset">{{$t('message.reset')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script >
  import ElButton from "element-ui/packages/button/src/button";
  import { Loading } from 'element-ui'

  export default {
    components: {ElButton},
    inject: ['reload'],
    data () {
      return  {
        count:0,
        countnum:0,
        appParameterTabIndex: 0, //APP参数，tab标签页,默认为第一页
        terminalParameterTabIndex:0, //终端参数模板，tab标签页，默认为第一页
        showType:0,
        appId:'',//新增的
        packageName:'',
        appName:'',
        description:'',
        company:'',
        version:'',
        queryFlag: false,
        enableUninstall:'',
        forceEditVisible: false,
        terminalParameter:{},
        appEditType:'',
        apkFileinput:'',
        parameterType :'',//0 为app 1为终端 2为资源文件
        upAppParameter:{},//app 参数上传
        upTerminalParameter:{},//终端参数上传
        terminalParameterFile:'',
        appParameterFile:'',
        originalAppParameterList:[],//
        originalTerminalParameterList:[],
        operateAppParameterList:[],//
        appParameterNameList:[],//app参数显示名集合（tabs pane名）
        operateTerminalParameterList:[],
        terminalParameterNameList:[],//app终端参数显示名集合（tabs pane名）
        isReloadData: true,//刷新标识
        logo:'static/img/uploadAppIcon.png',
        inputAppParameter:[
          {
            dataName:'',
            viewName:'',
            value:'',
          }
        ],
        appParameterList:[],
        inpuTerminalData:[{
          dataName: '',
          viewName: '',
          value: '',
          lengthFixed:'',
          maxLength:'',
          bulkEditMark:'',
          description:'',
        }],
        options: [
          {
            value: 1,
            label: this.$t('message.enable')
          },{
            value: 0,
            label: this.$t('message.disable')
          }
        ],
        yesOrNoSelect:[
          {
            value: 1,
            label: this.$t('message.true')
          },{
            value: 0,
            label: this.$t('message.false')
          }
        ],
        terminalEditIcon:'static/img/edit_disabled.png',
        appParameterEditIcon:'static/img/edit_disabled.png',
        imgCheck: this.$t('message.imgCheck'),
        xmlCheck: this.$t('message.xmlCheck'),
        uploadSuccess: this.$t('message.uploadSuccess'),
        submitSuccess: this.$t('message.submitSuccess'),
        inputCheck: this.$t('message.inputCheck'),
        fileCheck: this.$t('message.fileCheck'),
        terminalEditFlag:true,
        appParameterEditFlag:true,
        downType:0,
        downTime:'',
        editParameterDialogVisible : false,
        ediTerminalDialogVisible  :false,
        downloadsVisible:false,
        createBack: this.$t('message.createBack'),
        yes:this.$t('message.yes'),
        no:this.$t('message.no'),

        /* pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24;
          }
        }, */
        /*--------------------------------------------- 资源文件 start ---------------------------------------------*/
        addFileDialogVisible:false, // 新增页面显示标记
        resourceFileEditFlag: true, // 资源文件按钮可用标志，true：不可点击，false：可点击
        originalFileList:[], // 原始文件集合
        operateFileList:[], // 操作使用的文件集合
        delFileTaskIdList: [], // 被删除的资源文件所关联的任务ID
        fileFrom:{name:"", version:"", description:"", filename:"", size:"", md5:"", url:""}, // 新增页面From表单数据
        /*--------------------------------------------- 资源文件 end ---------------------------------------------*/

        /*--------------------------------------------- APP终端参数 start ---------------------------------------------*/
        atpSelectedTab:"", // 当前选中的Tab页Lable值
        atpCurrentPageNum: 1, //当前页码
        atpPageCount: 1, //总页数
        /*--------------------------------------------- APP终端参数 end ---------------------------------------------*/

        /*--------------------------------------------- APP参数 start ---------------------------------------------*/
        apSelectedTab:"", // 当前选中的Tab页Lable值
        apCurrentPageNum: 1, //当前页码
        apPageCount: 1, //总页数
        /*--------------------------------------------- APP参数 end ---------------------------------------------*/



      }
    },

    mounted() {
      this.init();
      this.initData();
      this.setQuery();

    },
    computed:{
      changeData() {
        const {
          appName,
          description,
          packageName,
          company,
          version,
          originalAppParameterList,
          originalTerminalParameterList,
          originalFileList,
          enableUninstall,
        } = this;
        return {
          appName,
          description,
          packageName,
          company,
          version,
          originalAppParameterList,
          originalTerminalParameterList,
          originalFileList,
          enableUninstall,
        }
      },
      changeParams(){
            const {
              inpuTerminalData,
              operateAppParameterList,
              inputAppParameter,
              operateTerminalParameterList
            }=this;

            return{
              inputAppParameter,
              inpuTerminalData,
              operateAppParameterList,
              operateTerminalParameterList
            }
      }
    },
    watch:{
      changeData: {
          handler(oldVal, newVal) {
            if (oldVal!=newVal && newVal.appName=="") {
                 this.count == 0;
            } else if (newVal == oldVal) {
              this.count == 0;
            }else  {
              this.count++;
            }
          },
          deep: true
        },
      changeParams:{
        handler(oldVal,newVal){
          console.log(oldVal,newVal);
          if(oldVal!=newVal && oldVal.inputAppParameter.dataName!=''){
            this.countnum==0;
          }else{
            this.countnum++;
          }
        },
        deep:true
      }
      },

    methods:{
      init(){
        this.appId = this.$route.query.id;
        console.log("HHHHHHHHHHHHH:"+JSON.stringify(this.$route.query.id));
        console.log("HHHHHHHHHHHHH:"+JSON.stringify(this.$route.query.version));
        console.log("HHHHHHHHHHHHH:"+JSON.stringify(this.$route.query.name));
      },
      // 初始化
      initData(){
        if(this.appId == 'newApp') {
          this.appEditType ='0';
        }else {
          this.appDetail(this.appId);
          this.appEditType ='1'
        };
      },
      //文件上传局部刷新方法
          reloadDiv(){
                    this.isReloadData=false;
                    this.$nextTick(function(){
                        this.isReloadData=true;
                    })
                    },
      // 权限设置
      setQuery() {
        let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
        this.queryFlag = !roleArr.includes(31);
      },

      // 查询APP详细信息
      appDetail(id){
        const that = this;
        let obj = {id: id};
        this.$axios({
          method: 'post',
          url: '/marketplace/app/detail',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.showErrorMsg(response.data.desc);
            return;
          }else {
            that.originalAppParameterList =[];
            that.originalTerminalParameterList =[];
            that.operateAppParameterList =[];
            that.operateTerminalParameterList =[];
            that.logo = response.data.logo;
            that.packageName = response.data.packageName;
            that.appName = response.data.appName;
            that.description = response.data.description;
            that.company = response.data.company;
            that.version = response.data.version;
            that.enableUninstall = response.data.enableUninstall;
            that.apkFileinput = response.data.fileName;
            that.resourceFileEditFlag = false;

            //保存app参数显示名集合
            if (response.data.appParameterNameList.length){
              for (let i=0; i<response.data.appParameterNameList.length; i++) {
                that.appParameterNameList.push(response.data.appParameterNameList[i]);
              }
            }
            this.apSelectedTab = that.appParameterNameList[0];
            if(response.data.appParameter.length) {
              that.appParameterEditIcon ='static/img/edit_active.png';
              that.appParameterEditFlag =false;
              for(let j=0;j < response.data.appParameter.length;j++) {
                that.originalAppParameterList.push(response.data.appParameter[j]);
                that.operateAppParameterList.push(response.data.appParameter[j]);
                //删除使用
                that.operateAppParameterList[j].index = j;
              }
            }

            //保存app终端参数显示名集合
            if (response.data.terminalParameterNameList.length){
              for (let j=0; j<response.data.terminalParameterNameList.length; j++) {
                that.terminalParameterNameList.push(response.data.terminalParameterNameList[j]);
              }
            }
            this.atpSelectedTab = that.terminalParameterNameList[0];
            if(response.data.terminalParameter.length) {
              that.terminalEditIcon = 'static/img/edit_active.png';
              that.terminalEditFlag = false;
              for(let i=0;i<response.data.terminalParameter.length;i++) {
                that.originalTerminalParameterList.push(response.data.terminalParameter[i]);
                that.operateTerminalParameterList.push(response.data.terminalParameter[i]);
                //删除使用
                that.operateTerminalParameterList[i].index = i;
              }
            }

            //保存资源文件参数集合 信息
            if(response.data.fileParameter.length){
              for(let i=0;i<response.data.fileParameter.length;i++) {
                that.originalFileList.push(response.data.fileParameter[i]);
                that.operateFileList.push(response.data.fileParameter[i]);
              }
            }

          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 退出编辑提示
      editCancel() {
        if(this.count>0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.$router.replace('/appManagement');
          })
        }else{
          this.$router.replace('/appManagement');
        }
      },

      clickDownloadCancel() {
        this.downloadsVisible = false;
        this.$router.replace('/appManagement');
      },
      valueFormatter(content){
        if(content.length >20){
          return content.substring(0,20) +'...';
        } else {
          return content;
        }
        console.log("content"+content);
      },
     /*app参数的编辑按钮*/
      showAppParaDiog(){
        if(!this.appParameterEditFlag) {
          /*this.editParameterDialogVisible = true;*/
          this.showType =1;
        }
      },
     /* 终端参数的编辑按钮*/
      showTerminalDiog(){
        if(!this.terminalEditFlag) {
          /* this.ediTerminalDialogVisible = true;*/
          this.showType =2;
        }
      },
    /*  终端导入参数的返回按钮*/
      initTerminalData(){
        this.operateTerminalParameterList=[];
        console.log(this.operateTerminalParameterList);
        for(let i=0;i<this.originalTerminalParameterList.length;i++){
          this.operateTerminalParameterList.push(this.originalTerminalParameterList[i]);

        }
        for(let dataItem of this.operateTerminalParameterList){
          dataItem.editFlag=false;
        }
        /*this.ediTerminalDialogVisible =false;*/
        /*this.showType =0;*/
        if(this.countnum>0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.showType = 0;
            this.reload();
          })
        }else{
          this.showType = 0;
        }
      },
      /*app导入的参数返回按钮*/
      initAppData(){
          this.operateAppParameterList = [];
          for (let i = 0; i < this.originalAppParameterList.length; i++) {
            this.operateAppParameterList.push(this.originalAppParameterList[i]);
          }
          for (let dataItem of this.operateAppParameterList) {
            dataItem.editFlag = false;
          }
          /*this.editParameterDialogVisible =false;*/
          /* this.showType =0;*/
        if(this.countnum>0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.showType = 0;
            this.reload();
          })
        }else{
          this.showType = 0;
        }
      },
    /*  app参数的输入框*/
      addAppParameter(row,viewName){
        if(row.dataName===''&& row.value==='' && viewName===''){
          return;
        }
        let obj={
          "dataName":row.dataName,
          "viewName":viewName,
          "value":row.value,
          "editFlag":false,
          "index":this.operateAppParameterList.length + 1
        };
        this.operateAppParameterList.push(obj);
        row.dataName ='';
        row.value ='';
      },
      // 新增终端参数
      addTerminalParameter(row,viewName){
        if(row.dataName===''&& row.value==='' && row.lengthFixed===''&& row.maxLength==='' && row.description && viewName===''){
          return;
        }
        let obj={
          "dataName":row.dataName,
          "viewName":viewName,
          "value":row.value,
          "lengthFixed":row.lengthFixed,
          "maxLength":row.maxLength,
          "bulkEditMark":row.bulkEditMark,
          "description":row.description,
          "editFlag":false,
          "index":this.operateTerminalParameterList.length + 1
        };
        this.operateTerminalParameterList.push(obj);
        row.dataName = '';
        row.value = '';
        row.lengthFixed = '';
        row.maxLength = '';
        row.description = '';
        row.bulkEditMark = '';
      },
      //点击行触发
      appParamterHandleEdit:function(row){
        console.log(row)
        //关闭其他编辑行
        for(let dataItem of this.operateAppParameterList){
          dataItem.editFlag=false;
        }
        //开启当前编辑行
        row.editFlag =true;
      },
      terminalHandleEdit:function(row){
        for(let dataItem of this.operateTerminalParameterList){
          dataItem.editFlag=false;
        }
        row.editFlag =true;
      },
      //根据index属性值来删除行
      delRowByIndex(index, rows){
        for (var i =0; i< rows.length; i++){
          if (rows[i].index == index) {
            rows.splice(i,1);
            break;
          }
        }
      },
      /* deleteRow(index, rows) {
        rows.splice(index, 1);
      }, */
      clickBB: function(row){
        console.log("点击前："+ row.editFlag);
        row.editFlag = false;
        console.log("点击后："+ row.editFlag);
      },
      appParameterInputClick() {
        this.parameterType=0;
        this.$refs.appParameterInput.click();
      },
      addTerminalParameterInputClick() {
        this.parameterType=1;
        this.$refs.addTerminalParameterInput.click();
      },
      addFileInputClick() {
        this.$refs.addFileInput.click();
      },
      addAppIconClick() {
        this.$refs.appIconUpload.click();
      },

     /* 导入apk文件*/
      clickAddFile() {
        // 开启遮罩层
        let loadingInstance = Loading.service({
          lock: true,
          text: 'Loading...',
          background: 'rgba(255, 255, 255, 0.5)'
        });

        const that = this;
        let fromData = new FormData();
        let files=this.$refs.addFileInput.files;
        fromData.append("file", this.$refs.addFileInput.files[0]);
        if (that.appId == 'newApp'){
          fromData.append("appId","");
        }else{
          fromData.append("appId",that.appId);
        }

        //文件大小校验
        let size = (files[0].size)/(1024*1024);
        if (size > 200) {
          loadingInstance.close();
          this.showErrorMsg(this.$i18n.t('message.fileCheck'))
          this.reloadDiv()
          return;
        }

        // 进行文件上传
        this.$axios({
          method: 'post',
          url: '/marketplace/app/apk',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: fromData,
          timeout:30*10000,
        }).then(response => {
          loadingInstance.close();
          if (response.data.resultCode != 0) {
            this.showErrorMsg(response.data.desc)
            return;
          } else {
            that.logo = response.data.apkInfo.appLogo;
            that.apkUrl = response.data.apkInfo.apkUrl;
            that.size = response.data.apkInfo.size;
            that.apkMd5 = response.data.apkInfo.apkMd5;
            that.packageName = response.data.apkInfo.packageName;
            that.version = response.data.apkInfo.version;
            that.appName = response.data.apkInfo.apkName;
            that.apkFileinput = response.data.apkInfo.fileName;
            that.resourceFileEditFlag = false;
            that.showSuccessMsg(this.uploadSuccess);
          }
        }).catch((err) => {
          console.log(err);
        })

        this.$refs.addFileInput.value = null;
      },
     /* 导入图片*/
      clickAddAppIcon(e) {
        let  files=  e.target.files[0];
        let length = files.name.split('.').length;
        let fileSuffix = files.name.split('.')[length-1];
        const reader = new FileReader();
        const that=this;
        reader.readAsDataURL(files);
        reader.onload = function(e){
          const mb = (e.total/1024)/1024;
          const _that = this;

          if(fileSuffix == "png" || fileSuffix == "jpg"|| fileSuffix == "jpeg") {

          } else {
            that.$message({
              type: "error",
              message: that.imgCheck,
              duration:'3000',
            });
            return;
          }
          that.logo = _that.result;
          that.logoPrefix = fileSuffix;
          that.appIcon = _that.result;
        }
        console.log("this.appIcon::"+this.appIcon);
      },
      /*添加参数*/
     clickAddParameter(e) {
        let files=  e.target.files[0];
        let length = files.name.split('.').length;
        let fileSuffix = files.name.split('.')[length-1];
        const reader = new FileReader();
        const that = this;
        reader.readAsDataURL(files);
        reader.onload = function(e){
          const mb = (e.total/1024)/1024;
          const _that = this;
          if (fileSuffix != "xml" && fileSuffix != "XML") {
            that.showErrorMsg(that.xmlCheck);
            return;
          }
          if(that.parameterType == 0) {
            that.upAppParameter.file = _that.result;
            that.upAppParameter.filePrefix = fileSuffix;
            that.appParameterUpload();
            that.$refs.appParameterInput.value = null;
          }
          else if(that.parameterType == 1) {
            that.upTerminalParameter.file = _that.result;
            that.upTerminalParameter.filePrefix = fileSuffix;
            that.terminalParameterUpload();
            that.$refs.addTerminalParameterInput.value = null;
          }
        };
      },
      // APP参数导入
     appParameterUpload() {
        let that = this;
        let obj = {
          file: this.upAppParameter.file,
          filePrefix:this.upAppParameter.filePrefix
        };
        this.$axios({
          method: 'post',
          url: '/marketplace/app/upload/appParameter',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.showErrorMsg(response.data.desc)
            return;
          }else {
            that.appParameterNameList = [];
            that.operateAppParameterList=[];
            that.originalAppParameterList=[];
            that.appParameterEditFlag = false;
            that.appParameterEditIcon ='static/img/edit_active.png';
            // 初始化参数名称列表
            if (response.data.appParameterNameList.length){
              for (let i=0; i<response.data.appParameterNameList.length; i++) {
                that.appParameterNameList.push(response.data.appParameterNameList[i]);
              }
            }
            this.apSelectedTab = that.appParameterNameList[0];
            // 初始化参数列表
            for(let i=0;i < response.data.appParameter.length;i++) {
              that.originalAppParameterList.push(response.data.appParameter[i]);
              that.operateAppParameterList.push(response.data.appParameter[i]);
              that.operateAppParameterList[i].index = i;
            }
            that.showSuccessMsg(this.uploadSuccess)
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      // 终端参数模板导入
      terminalParameterUpload() {
        let that = this;
        let obj = {
          file: this.upTerminalParameter.file,
          filePrefix:this.upTerminalParameter.filePrefix
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/upload/terminalParameter',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.terminalEditIcon = 'static/img/edit_active.png';
            that.terminalEditFlag = false;
            that.originalTerminalParameterList = [];
            that.operateTerminalParameterList = [];
            that.terminalParameterNameList = [];

            // 初始化参数名称列表
            if (response.data.terminalParameterNameList.length){
              for (let i=0; i<response.data.terminalParameterNameList.length; i++) {
                that.terminalParameterNameList.push(response.data.terminalParameterNameList[i]);
              }
            }
            this.atpSelectedTab = that.terminalParameterNameList[0];

            for(let i=0;i<response.data.terminalParameter.length;i++) {
              that.originalTerminalParameterList.push(response.data.terminalParameter[i]);
              that.operateTerminalParameterList.push(response.data.terminalParameter[i]);
            }
            that.showSuccessMsg(that.uploadSuccess);
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      saveTerminalData(){
        this.ediTerminalDialogVisible = false;
        this.originalTerminalParameterList=[];
        for(let i=0;i<this.operateTerminalParameterList.length;i++) {
          this.originalTerminalParameterList.push(this.operateTerminalParameterList[i]);
        }
        this.showType =0;
      },
      saveAppData(){
        this.editParameterDialogVisible = false;
        for(let i=0;i<this.originalAppParameterList.length;i++) {
          let originApp=this.originalAppParameterList[i];
          for(let j=0;j<this.operateAppParameterList.length;j++) {
            let operateApp=this.operateAppParameterList[j];
            /*console.log(this.operateAppParameterList[j]);*/
            if(originApp.dataName === operateApp.dataName && originApp.viewName === operateApp.viewName && originApp.value === operateApp.value  && originApp.description === operateApp.description) {

            }else {

            }
          }
        }

        this.originalAppParameterList = [];
        for(let i=0;i<this.operateAppParameterList.length;i++){
          this.originalAppParameterList.push(this.operateAppParameterList[i]);
        }
        this.showType =0;
      },
      downLoad(){
        let that = this;
        let obj = {
          appId:this.$route.query.id,
          appParameter:this.originalAppParameterList,
          terminalParameter:this.originalTerminalParameterList,
          downloadType:this.downType,
          downloadDateStart:this.downTime
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/task/add/appParameter',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.downloadsVisible = false;
            this.$message({
              type: "success",
              message: this.uploadSuccess,
              duration:'3000',
            });

            this.$router.replace('/appManagement');
          }
        }).catch((err) => {
          console.log(err);
        });
      },
     /* 新增还是编辑的区分*/
      saveAppMessage(){
        if(this.appEditType =='0'){
          this.addApp();
        }
        else if(this.appEditType =='1'){
          this.editApp();
        }
      },

     addApp(){
        // 参数校验
        if( this.appName=="" || this.apkUrl =="" || this.logo ==""
            || this.packageName == "" || this.description =="" || this.company == ""){
          this.showErrorMsg(this.inputCheck);
          return false;
        }

        let obj = {
          apkUrl: this.apkUrl,
          size: this.size,
          apkMd5: this.apkMd5,
          appLogo: this.logo,
          logoPrefix: this.logoPrefix,
          packageName: this.packageName,
          appName: this.appName,
          description: this.description,
          company: this.company,
          version: this.version,
          enableUninstall: this.enableUninstall,
          appParameter: this.originalAppParameterList,
          terminalParameter: this.originalTerminalParameterList,
          fileParameter:this.originalFileList
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/add',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            this.$message({
              type: "success",
              message: this.submitSuccess,
              duration:'3000',
            });
            window.history.go(-1);
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      /*编辑提交这块*/
      editApp(){
        if( this.appName=="" || this.packageName =="" || this.description =="" || this.company == ""){
          this.showErrorMsg(this.inputCheck);
          return false;
        }
        let obj = {
          id:this.appId,
          apkUrl:this.apkUrl,
          size:this.size,
          apkMd5:this.apkMd5,
          appLogo:this.logo,
          packageName:this.packageName,
          appName:this.appName,
          description:this.description,
          company:this.company,
          version:this.version,
          enableUninstall: this.enableUninstall,
          appParameter: this.originalAppParameterList,
          terminalParameter:this.originalTerminalParameterList,
          fileParameter:this.originalFileList
        };
        this.$axios({
          method: 'post',
          url: '/marketplace/app/edit',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.showErrorMsg(response.data.desc);
            return;
          }else {
            this.showSuccessMsg(this.submitSuccess);
            if(response.data.inRunningTaskFlag == 1 ) {
              this.forceEditVisible = true;
            }else {
              let parameterChange = response.data.parameterChange;
              let resourecFileChange = response.data.resourecFileChange;
              if(parameterChange === 1 || resourecFileChange === 1) {
                sessionStorage.setItem('appId', this.$route.query.id);
                sessionStorage.setItem('parameterChange', parameterChange);
                sessionStorage.setItem('resourecFileChange', resourecFileChange);
                this.$router.push({path:'/appDownload',query:{routerAppDetail:this.$route.query.name+"-"+this.$route.query.version}});
              }else {
                this.$router.replace('/appManagement');
              }
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      forceEdit(){
        if(this.appName==""){
          this.$message({
            type: "error",
            message: this.inputCheck,
            duration:'3000',
          });
          return false;
        }
        if(this.packageName ==""){
          this.$message({
            type: "error",
            message: this.inputCheck,
            duration:'3000',
          });
          return false;
        }
        if(this.description ==""){
          this.$message({
            type: "error",
            message: this.inputCheck,
            duration:'3000',
          });
          return false;
        }
        if(this.company == ""){
          this.$message({
            type: "error",
            message: this.inputCheck,
            duration:'3000',
          });
          return false;
        }
        const that =this;
        let obj = {
          id:this.$route.query.id,
          apkUrl:this.apkUrl,
          size:this.size,
          apkMd5:this.apkMd5,
          appLogo:this.logo,
          // logoPrefix:this.logoPrefix,
          packageName:this.packageName,
          appName:this.appName,
          description:this.description,
          company:this.company,
          version:this.version,
          enableUninstall: this.enableUninstall,
          appParameter: this.originalAppParameterList,
          terminalParameter:this.originalTerminalParameterList
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/forceEdit',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            this.$message({
              type: "success",
              message: this.submitSuccess,
              duration:'3000',
            });

            if(response.data.parameterChange === 1) {
              sessionStorage.setItem('appId', this.$route.query.arry.id);
              // sessionStorage.setItem('appParameter', this.originalAppParameterList.map(item => JSON.stringify(item)).join('-'));
              // sessionStorage.setItem('terminalParameter', this.originalTerminalParameterList.map(item => JSON.stringify(item)).join('-'));
              this.$router.replace('/appDownload');
            }else {
              this.$router.replace('/appManagement');
            }

            /*window.history.go(-1);*/
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      atpFilterShowList(list,label){
        let temp = this.yyUtils.filterShowList(list,label,this.atpCurrentPageNum);
        this.atpPageCount = temp.pageCount;
        return temp.showList;
      },
      apFilterShowList(list,label){
        let temp = this.yyUtils.filterShowList(list,label,this.apCurrentPageNum);
        this.apPageCount = temp.pageCount;
        return temp.showList;
      },
      //添加app参数选项卡窗格
      addAppParameterTabPane(){
        this.$prompt(this.$i18n.t('message.name'),this.$i18n.t('message.info'),{
          confirmButtonText: this.$i18n.t('message.sure'),
          cancelButtonText: this.$i18n.t('message.cancel'),
          //此处为非空校验
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: this.$i18n.t('message.inputCheck'),
          inputPlaceholder: this.$i18n.t('message.enterContent')
        }).then(({value}) => {
          let size = this.appParameterNameList.length;
          this.appParameterNameList.push(value);
          if (size < this.appParameterNameList.length){
            this.$message({type:'success',message:this.$i18n.t('message.addSuccess')});
          }else {
            this.$message({type:'info',message:this.$i18n.t('message.cancel')});
          }
        });
      },
      //添加app终端参数选项卡窗格
      addTerminalParameterTabPane(){
        this.$prompt(this.$i18n.t('message.name'),this.$i18n.t('message.info'),{
          confirmButtonText: this.$i18n.t('message.sure'),
          cancelButtonText: this.$i18n.t('message.cancel'),
          //此处为非空校验
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: this.$i18n.t('message.inputCheck'),
          inputPlaceholder: this.$i18n.t('message.enterContent')
        }).then(({value}) => {
          let size = this.terminalParameterNameList.length;
          this.terminalParameterNameList.push(value);
          if (size < this.terminalParameterNameList.length){
            this.$message({type:'success',message:this.$i18n.t('message.addSuccess')});
          }else {
            this.$message({type:'info',message:this.$i18n.t('message.cancel')});
          }
        });
      },

      /************************************************ 资源文件相关 start ******************************************/
      // 显示错误信息
      showErrorMsg(msg){
       this.showMsg("error",msg);
      },

      // 显示警告信息
      showWarningMsg(msg){
        this.showMsg("warning",msg);
      },

      //显示成功信息
      showSuccessMsg(msg){
        this.showMsg("success",msg);
      },

      //显示信息
      showMsg(type,msg){
        this.$message({
          type: type,
          message: msg,
          duration: '3000'
        })
      },

      //显示资源文件列表页面
      showFileParaDiog(){
          this.showType =3;
          this.searchDelFileTaskIds();
      },

      // 查询该APP关联的未终止的资源文件下载任务
      searchDelFileTaskIds(){
        let obj = new Object();
        obj.packageName = this.packageName;
        obj.version = this.version;
        obj.type = 4; // 4:资源文件下载
        this.$axios({
          method:"post",
          url:"/marketplace/task/search/ids",
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          async: false,
          data: obj
        }).then( response => {
          if (response.data.resultCode != 0) {
            this.showErrorMsg(response.data.desc);
            return;
          }
          this.delFileTaskIdList = response.data.taskIdList;
        }).catch((err) => {
          console.log(err);
        })
      },

      // 删除资源文件
     delResourceFile(index, rows) {
        this.$confirm("是否删除资源文件", this.warn, {
          confirmButtonText: this.$i18n.t('message.yes'),
          cancelButtonText: this.$i18n.t('message.no'),
          type: 'warning'
        }).then(() => {
           // 说明： 新增的资源文件，就无须判断是否终止任务
           let id = rows[index].id;
           if (typeof (id) == "undefined"){
             rows.splice(index, 1);
             return;
           }

           // 说明：本地资源文件下载任务ID集合为空，已查询但是空值,亦或是已被终止则值被清空
           if(this.delFileTaskIdList.length == 0)
              rows.splice(index, 1);

           // 说明：存在资源文件下载任务询问其是否终止
           else
              this.isStopFileTask(index, rows);

        });
      },

      // 询问终止资源文件下载任务
      isStopFileTask(index, rows){
        this.$confirm('如果删除该资源文件会导致所有包含这个资源文件的下载任务都被取消，是否继续删除', this.warn, {
          confirmButtonText: this.$i18n.t('message.yes'),
          cancelButtonText: this.$i18n.t('message.no'),
          type: 'warning'
        }).then(() => {
          this.stopFileTask(index, rows);
        });
      },

      // 终止资源文件下载任务
      stopFileTask(index, rows){
        let obj = new Object();
        obj.taskIds = this.delFileTaskIdList;
        this.$axios({
          method:"post",
          url:"/marketplace/task/stop",
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          async: false,
          data: obj
        }).then( response => {
          if (response.data.resultCode != 0) {
            this.showErrorMsg(response.data.desc);
            return;
          }
          this.delFileTaskIdList = [];
          rows.splice(index, 1);
        }).catch((err) => {
          console.log(err);
        })
      },

      //清空表单数据
      newFileInfoReset(){
        this.fileFrom.filename = '';
        this.fileFrom.name = '';
        this.fileFrom.size = '';
        this.fileFrom.md5 = '';
        this.fileFrom.description = '';
        this.fileFrom.type = '';
        this.fileFrom.url = '';
        this.fileFrom.version = '';
        this.$refs.appResourceFileBtn.value = null;
      },

      // 关闭窗口前的提示
      newFileDlgBeforeClose(done){
        // 如果没有值，则可以直接关闭
        if (this.fileFrom.filename == '' && this.fileFrom.name == '' && this.fileFrom.description == '' && this.fileFrom.version == '') {
          this.newFileInfoReset();
          done();
        }
        // 如果有值，则需要询问一下
        else{
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.newFileInfoReset();
            done();
          })
        }
      },

      // 打开资源文件添加页面
      openAddResourceFile(){
        let length = this.operateFileList.length;
        if (length >= 20){
          this.showWarningMsg(this.$i18n.t('message.appResourceFileMax'));
          return;
        }
        this.addFileDialogVisible = true
      },

      //复制表单数据
      newFileInfoCopy: function(){
        const that = this;
        let tempFileFrom = {};
        tempFileFrom.filename = that.fileFrom.filename;
        tempFileFrom.name = that.fileFrom.name;
        tempFileFrom.size = that.fileFrom.size;
        tempFileFrom.md5 = that.fileFrom.md5;
        tempFileFrom.description = that.fileFrom.description;
        tempFileFrom.url = that.fileFrom.url;
        tempFileFrom.version = that.fileFrom.version;
        return tempFileFrom;
      },

      //表单数据提交
      newFileInfoSubmit(){
        // 校验是否上传了文件
        if(this.fileFrom.url == ""){
          this.showErrorMsg(this.$i18n.t('message.UploadResource'));
          return;
        }
        let tempFileFrom = this.newFileInfoCopy();
        this.operateFileList.push(tempFileFrom);
        this.newFileInfoReset();
        this.addFileDialogVisible = false;

      },

      appResourceFileBtnClick(){
        this.parameterType=2;
        this.$refs.appResourceFileBtn.click();
      },

      //点击上传资源文件
      clickAddAppResourceFile(){
        let loadingInstance = Loading.service({
          lock: true,
          text: 'Loading...',
          background: 'rgba(255, 255, 255, 0.5)'
        });

        let formData = new FormData();
        const that = this;
        let files = this.$refs.appResourceFileBtn.files;
        formData.append("file",files[0]);

        // 文件大小校验
        let size = files[0].size/(1024*1024);
        if (size > 90){
          loadingInstance.close();
          this.showErrorMsg(this.$i18n.t('message.fileCheck'));
          this.$refs.appResourceFileBtn.value = null;
          return;
        }

        // 文件名校验
        let name = files[0].name;
        for(let i=0; i<this.operateFileList.length; i++){
          let tempName = this.operateFileList[i].name;
          if (tempName == name) {
            loadingInstance.close();
            this.showErrorMsg(this.$i18n.t('message.resourceNameSameCheck'));
            this.$refs.appResourceFileBtn.value = null;
            return;
          }
        }

        this.$axios({
            method:"post",
            url:"/marketplace/app/file",
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: formData,
            timeout: 9 * 10000
        }).then( response => {
            loadingInstance.close();
            //上传失败，报个错吧
            if (response.data.resultCode != 0) {
                this.showErrorMsg(response.data.desc);
                return;
            }
            //上传成功保存一下数据
            that.fileFrom.filename = response.data.fileData.filename;
            that.fileFrom.name = response.data.fileData.name;
            that.fileFrom.md5 = response.data.fileData.fileMD5;
            that.fileFrom.size = response.data.fileData.size;
            that.fileFrom.url = response.data.fileData.url;
        }).catch((err) => {
            console.log(err);
        })
        //清理上传的文件
        this.$refs.appResourceFileBtn.value = null;
      },

      //保存对象集合信息
      saveFileData(){
        this.originalFileList = [];
        for (let i=0; i< this.operateFileList.length; i++){
          this.originalFileList.push(this.operateFileList[i]);
        }
        this.showType = 0;
      },

      //将操作数据集初始化成初始的数据集
      initFileListData(){
        if(this.originalFileList.length==this.operateFileList.length){
          this.showType = 0;
          //如果不修改则不提示
        }else{
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.operateFileList = [];
            for (let i=0; i< this.originalFileList.length; i++){
              this.operateFileList.push(this.originalFileList[i]);
            }
            this.showType = 0;
            done();
          })
        }
      },
      /************************************************ 资源文件相关 end ********************************************/

      /************************************************ APP终端参数 start ********************************************/
      // 终端参数Tabs点击事件
      atpTabClick(tab){
        this.atpCurrentPageNum = 1;
        this.atpSelectedTab = tab.label;
      },

      // 终端参数 页码改变事件
      atpPageChange(currentPageNum){
        this.atpCurrentPageNum = currentPageNum;
        this.atpFilterShowList(this.operateTerminalParameterList, this.atpSelectedTab);
       /* this.$refs.table.bodyWrapper.scrollTop =0;//滑动条跳到初始位置 */
      },
      /************************************************ APP终端参数 end ********************************************/

      /************************************************ APP参数 start ********************************************/
      // App参数Tabs点击事件
      apTabClick(tab){
        this.apCurrentPageNum = 1;
        this.apSelectedTab = tab.label;
      },

      // APP参数 页码改变事件
      apPageChange(currentPageNum){
        this.apCurrentPageNum = currentPageNum;
        this.apFilterShowList(this.operateAppParameterList, this.apSelectedTab);
        //改变当前页时，滑动条滑到顶部
        this.$nextTick(() => {
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        })

      }
      /************************************************ APP参数 end ********************************************/
    },
  }

</script>

<style scoped lang="css">
  .editApp-container {
    /*background-color: #F0F0F0;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
    font-family: 'Arial';
    padding: 0 0 10px 0;
  }
  .editApp-body-container {
    padding:0 30px 0 30px;
    width:100%;
  }
  .icon-tip-con {
    justify-content: flex-end;
    height: 90px;
    margin-left: 10px;
    color: #c0c4cc;
  }
  .redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
  }
  .title {
    padding-left:0;
  }
  .avatar-uploader,.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader,.el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .edit-body {
    padding: 20px 35px 20px 100px;
  }
  .app-body,.te-body,.file-body{
    padding: 15px 20px 15px 20px;
  }
  .app-file-container {
    /*border-bottom:1px solid #BBBBBB;*/
  }
  .app-message-container {
    padding:10px 0;
  }
  .left-app-message-container,.right-app-message-container{
    flex: 1;
    padding-right: 30px;
  }
  .right-app-message-container {
    justify-content: space-between;
    padding-left: 30px;
  }
  .edit-app-item {
    padding: 6px 0;
    align-items: center;
  }
  .upload-demo {
    align-items: center;
  }
  .app-div-name {
    line-height: 26px;
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    text-align: left;
  }
  .item-name {
    /* width: 200px; */
    font-family: 'Arial';
    font-size: 14px;
    /* text-align: left; */
  }
  .long-item-name {
    /* width: 220px; */
    font-family: 'Arial';
    font-size: 14px;
    text-align: left;
  }
  .el-input,.el-textarea{
    width: 16vw;
  }
  .save-app-btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: #58D56D;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: center;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
  }
  .uploadFile{
    /*background: url("../static/img/file_active.png") center center/20px 20px no-repeat;*/
    width: 20px;
    height: 20px;
    border:none;
    margin-left: 10px;
    padding:0;
    font-size: 0;
  }
  .edit-parameter-btn {
    /* background: url("../static/img/edit_disabled.png") center center/20px 20px no-repeat;*/
    width: 20px;
    height: 20px;
    border:none;
    margin-left: 5px;
    padding:0;
  }
  .el-upload-list__item:first-child {
    margin-top: 0!important;
  }
  .el-upload-list__item {
    margin-top: 0!important;
  }
  .addFileInput {
    display: none;
  }
  .appIconImg {
    width: 90px;
    height: 90px;
    border-radius: 3px;
    object-fit:cover;
  }
  .delete-btn {
    width: 20px;
    height: 20px;
  }
  .xml-length-container {
    color: rgba(16, 16, 16, 1);
    text-align: left;
    padding: 10px 0;
  }
  .footer-contain {
    justify-content: flex-end;
  }
  .input-margin {
    margin-right: 20px;
  }
  .edit-left {
    width: 250px;
    justify-content: flex-end;
    padding-right: 8px;
  }
  .verifone-tabs{
    padding-top: 15px;
  }
  .file-table{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/AppEdit.vue